export const CLICK_OUTSIDE_IGNORE_ATTR_NAME = 'data-click-outside-ignore';
